import React, {Component} from "react";
import {Link} from "react-router-dom";
import "./InvalidCaseStudy.css";

export default class InvalidCaseStudy extends Component
{
	render()
	{
		return (
			<div className="invalid-study">
				<div className="text">
					<div className="head">
						Sorry about that
					</div>

					<div className="subhead">
						I couldn't find the case study you were looking for.
					</div>

					<div className="subhead">
						If you feel like this was an error, please send an email to <strong>andrew.guterman1@gmail.com</strong>.
					</div>

					<Link to="/">
						Return to Home
					</Link>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/CaseStudy/InvalidCaseStudy/InvalidCaseStudy.js